import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild, AfterViewInit } from '@angular/core';

import 'amcharts3';
import 'amcharts3/amcharts/plugins/responsive/responsive.js';
import 'amcharts3/amcharts/serial.js';

import 'ammap3';
import 'ammap3/ammap/maps/js/worldLow';

import { DashboardWidgetLookup, DashboardWidgetContent } from '@serengeti/serengeti-dashboard';
import { WizardResourceMapService } from './wizard-resource-map.service';

@DashboardWidgetLookup('WizardResourceMapComponent')
@Component({
  selector: 'app-wizard-resource-map',
  templateUrl: './wizard-resource-map.component.html',
  styleUrls: ['./wizard-resource-map.component.scss']
})
export class WizardResourceMapComponent implements OnInit, DashboardWidgetContent {

  @Input() configuration: any;
  @Input() chartClass: string;
  @Output() onReady = new EventEmitter<any>();

  @ViewChild('mapSelector', {static: false}) public _selector: ElementRef;

  constructor(
    private resourceMapService: WizardResourceMapService
  ) {
    this.resourceMapService.load().subscribe(( data ) => {
      this.configuration = data;

      if (this._selector && this.configuration) {
        const chart = AmCharts.makeChart(this._selector.nativeElement,  this.configuration);
        this.onReady.emit(chart);
      }  
    });

  }

  property(): boolean {
    return false;
  }
  
  configure(setting: any): void {
  }

  ngOnInit() {
  }

}
